export const faqContent = {
  general: [
    {
      category: 'General',
      categoryHu: 'Általános',
      question: 'What are your opening hours?',
      questionHu: 'Mik a nyitvatartási idők?',
      answer: 'Parking: 24/7 | Hand Car Wash: Mon–Sat (08:00–18:00)',
      answerHu: 'Parkoló: 24/7 | Kézi Autómosó: H–Szo (08:00–18:00)'
    },
    {
      category: 'General',
      categoryHu: 'Általános',
      question: 'Do I need to book in advance?',
      questionHu: 'Előre kell foglalnom?',
      answer: 'Walk-ins are welcome, but booking ahead guarantees a fast check-in and a reserved spot during busy travel periods.',
      answerHu: 'Bejelentkezés nélkül is fogadunk, de az előzetes foglalás gyors bejelentkezést és lefoglalt helyet biztosít a forgalmas időszakokban.'
    },
    {
      category: 'General',
      categoryHu: 'Általános',
      question: 'What payment methods do you accept?',
      questionHu: 'Milyen fizetési módokat fogadtok el?',
      answer: 'We accept cash, major debit/credit cards and bank transfers. Contactless payment is available.',
      answerHu: 'Elfogadunk készpénzt, bank- és hitelkártyákat, valamint átutalást. Elérhető az érintésmentes fizetés.'
    }
  ],
  parking: [
    {
      category: 'Parking',
      categoryHu: 'Parkolás',
      question: 'How far are you from the airport?',
      questionHu: 'Milyen messze vagytok a repülőtértől?',
      answer: 'We are only a few minutes away. After check-in we shuttle you directly to the terminal and pick you up on return.',
      answerHu: 'Pár percre vagyunk. Bejelentkezés után saját transzferrel visszük a terminálhoz, érkezéskor pedig felveszünk.'
    },
    {
      category: 'Parking',
      categoryHu: 'Parkolás',
      question: 'Is the parking area secure?',
      questionHu: 'Biztonságos a parkoló?',
      answer: 'Yes. The lot is fenced, well lit, and secured 24/7 with on-site staff.',
      answerHu: 'Igen. A parkoló bekerített, jól megvilágított, és 0–24-ben helyszíni személyzet felügyeli.'
    },
    {
      category: 'Parking',
      categoryHu: 'Parkolás',
      question: 'What happens if my flight is delayed?',
      questionHu: 'Mi történik, ha késik a járatom?',
      answer: 'No problem. Share your flight number and we monitor delays so your transfer and parking remain secured until you arrive.',
      answerHu: 'Nem gond. Adja meg a járatszámot, figyeljük a késéseket, a transzfer és a parkolás biztosítva marad, amíg megérkezik.'
    },
    {
      category: 'Parking',
      categoryHu: 'Parkolás',
      question: 'Can I leave my keys with you?',
      questionHu: 'Nálatok hagyhatom a kulcsot?',
      answer: 'Yes. Keys are sealed, coded and stored securely in a locker until you return.',
      answerHu: 'Igen. A kulcsokat lezárva, kódolva és biztonságos szekrényben tároljuk a visszaérkezéséig.'
    },
    {
      category: 'Parking',
      categoryHu: 'Parkolás',
      question: 'Is there a maximum parking duration?',
      questionHu: 'Van maximális parkolási időtartam?',
      answer: 'No maximum limit. For stays longer than 30 days, please contact us for special pricing.',
      answerHu: 'Nincs maximális limit. 30 napnál hosszabb parkoláshoz kérjük, vegye fel velünk a kapcsolatot speciális árazásért.'
    }
  ],
  services: [
    {
      category: 'Services',
      categoryHu: 'Szolgáltatások',
      question: 'Can you wash my car while it is parked?',
      questionHu: 'Meg tudjátok mosni az autót, amíg parkol?',
      answer: 'Yes. Add a car wash package to your booking and we will deliver the car freshly cleaned when you return.',
      answerHu: 'Igen. Foglalásához kérhet autómosást, az autót frissen adjuk vissza, amikor visszaér.'
    },
    {
      category: 'Services',
      categoryHu: 'Szolgáltatások',
      question: 'What car wash packages do you offer?',
      questionHu: 'Milyen autómosó csomagokat kínáltok?',
      answer: 'We offer exterior wash, interior cleaning, and full detailing packages. All can be added when booking your parking.',
      answerHu: 'Kínálunk külső mosást, belső tisztítást és teljes körű tisztítási csomagokat. Mindegyik hozzáadható a parkolás foglalásakor.'
    },
    {
      category: 'Services',
      categoryHu: 'Szolgáltatások',
      question: 'Do you offer any other services?',
      questionHu: 'Kínáltok egyéb szolgáltatásokat?',
      answer: 'Yes, we can handle minor maintenance tasks like tire pressure checks. Contact us for specific requests.',
      answerHu: 'Igen, elvégzünk kisebb karbantartási feladatokat, mint gumiabroncs nyomásellenőrzés. Különleges kérésekkel vegye fel velünk a kapcsolatot.'
    }
  ],
  booking: [
    {
      category: 'Booking',
      categoryHu: 'Foglalás',
      question: 'How do I make a booking?',
      questionHu: 'Hogyan foglalhatok?',
      answer: 'You can book online through our website, call us at +36 70 585 9959, or email info@atgroup.hu.',
      answerHu: 'Foglalhat weboldalunkon, telefonon a +36 70 585 9959 számon, vagy e-mailben az info@atgroup.hu címen.'
    },
    {
      category: 'Booking',
      categoryHu: 'Foglalás',
      question: 'Can I change or cancel my booking?',
      questionHu: 'Módosíthatom vagy lemondhatom a foglalásomat?',
      answer: 'Yes. Free changes or cancellations up to 12 hours before arrival. Contact us to modify your reservation.',
      answerHu: 'Igen. Érkezés előtt 12 óráig ingyenesen módosítható vagy lemondható. Vegye fel velünk a kapcsolatot a foglalás módosításához.'
    },
    {
      category: 'Booking',
      categoryHu: 'Foglalás',
      question: 'What information do I need to provide?',
      questionHu: 'Milyen információkat kell megadnom?',
      answer: 'We need your arrival and departure dates, flight number, license plate, and contact details for a smooth check-in.',
      answerHu: 'Szükségünk van az érkezési és távozási dátumokra, járatszámra, rendszámra és elérhetőségekre a zökkenőmentes bejelentkezéshez.'
    },
    {
      category: 'Booking',
      categoryHu: 'Foglalás',
      question: 'What should I bring on arrival?',
      questionHu: 'Mit hozzak magammal érkezéskor?',
      answer: 'Have your booking confirmation, valid ID, and vehicle registration ready. Check-in takes just 2 minutes.',
      answerHu: 'Legyen kéznél a foglalási visszaigazolás, érvényes személyi igazolvány és a forgalmi engedély. A bejelentkezés mindössze 2 percet vesz igénybe.'
    }
  ]
};

export const allFaqs = Object.values(faqContent).flat();
